import { PayloadAction } from '@reduxjs/toolkit'
import {
  AdminSliceState,
  AdminStaticsObject,
  FilterUserStatusOption,
  FilterUserTypeOption,
  UsersAdmin,
  Withdrawal
} from 'src/core/models'
import {
  AdminDeposit,
  AdminTransfer,
  PurchaseDocument
} from 'src/core/models/admin-statics.type'
import { initialState } from './state'

const reducers = {
  /* Generate Certificate Reducers */
  setGenerateCertificateLoading: (
    state: AdminSliceState,
    action: PayloadAction<boolean>
  ) => {
    state.generateCertificate.loading = action.payload
  },
  setGenerateCertificateResponse: (
    state: AdminSliceState,
    action: PayloadAction<any>
  ) => {
    state.generateCertificate.response = action.payload
  },
  setGenerateCertificateError: (
    state: AdminSliceState,
    action: PayloadAction<string>
  ) => {
    state.generateCertificate.error = action.payload
  },

  /* Admin Statics Reducers */
  setAdminStaticsLoading: (
    state: AdminSliceState,
    action: PayloadAction<boolean>
  ) => {
    state.adminStatics.loading = action.payload
  },
  setAdminStaticsData: (
    state: AdminSliceState,
    action: PayloadAction<AdminStaticsObject>
  ) => {
    const data = action.payload
    state.adminStatics.userEmail = data.userEmail
    state.adminStatics.usersPendinToBeValidated =
            data.usersPendinToBeValidated
    state.adminStatics.transactionsCount = data.transactionsCount
    state.adminStatics.transactionsValue = data.transactionsValue
  },
  resetAdminStaticsData: (state: AdminSliceState) => {
    state.adminStatics = initialState.adminStatics
  },

  /* Massive Calculation Reducers */
  setMassiveCalculationStep: (
    state: AdminSliceState,
    action: PayloadAction<number>
  ) => {
    state.massiveCalculation.step = action.payload
    if (action.payload === 1) {
      const { country, distanceKlm, vehicleModel, vehicleFuel } =
                state.massiveCalculation.carKeys
      state.massiveCalculation.isNextButtonDisabled = [
        country,
        distanceKlm,
        vehicleModel,
        vehicleFuel
      ].includes(null)
      const { from, to, paxes, classType, roundtrip } =
                state.massiveCalculation.planeKeys
      state.massiveCalculation.isNextButtonDisabled = [
        from,
        to,
        paxes,
        classType,
        roundtrip
      ].includes(null)
      const {
        from: fromPar,
        to: toPar,
        weigth,
        fleetType
      } = state.massiveCalculation.parcelKeys
      state.massiveCalculation.isNextButtonDisabled = [
        fromPar,
        toPar,
        weigth,
        fleetType
      ].includes(null)
    }
  },
  resetMassiveCalculationState: (state: AdminSliceState) => {
    state.massiveCalculation = initialState.massiveCalculation
  },
  setMassiveCalculationKeys: (
    state: AdminSliceState,
    action: PayloadAction<any>
  ) => {
    state.massiveCalculation.fileKeys = action.payload
  },
  setMassiveCalculationExcelData: (
    state: AdminSliceState,
    action: PayloadAction<any>
  ) => {
    state.massiveCalculation.excelData = action.payload
  },
  setMassiveCalculationFileName: (
    state: AdminSliceState,
    action: PayloadAction<string>
  ) => {
    state.massiveCalculation.fileName = action.payload
  },
  resetMassiveCalculationFileData: (state: AdminSliceState) => {
    state.massiveCalculation.fileName = ''
    state.massiveCalculation.fileKeys = []
    state.massiveCalculation.excelData = []
  },
  setMassiveCalculationNextButtonDisabled: (
    state: AdminSliceState,
    action: PayloadAction<boolean>
  ) => {
    state.massiveCalculation.isNextButtonDisabled = action.payload
  },
  setMassiveCalculationUrl: (
    state: AdminSliceState,
    action: PayloadAction<string>
  ) => {
    state.massiveCalculation.calculeUrl = action.payload
    const calculeUrl = state.massiveCalculation.calculeUrl
    if (calculeUrl?.endsWith('plane/public/')) {
      const { from, to, paxes, classType, roundtrip } =
                state.massiveCalculation.planeKeys
      state.massiveCalculation.isNextButtonDisabled = [
        from,
        to,
        paxes,
        classType,
        roundtrip
      ].includes(null)
    } else if (calculeUrl?.endsWith('calculate_cars_co2/')) {
      const { country, distanceKlm, vehicleModel, vehicleFuel } =
                state.massiveCalculation.carKeys
      state.massiveCalculation.isNextButtonDisabled = [
        country,
        distanceKlm,
        vehicleModel,
        vehicleFuel
      ].includes(null)
    } else if (calculeUrl?.endsWith('domestic/delivery/massive')) {
      const { from, to, weigth, fleetType } =
                state.massiveCalculation.parcelKeys
      state.massiveCalculation.isNextButtonDisabled = [
        from,
        to,
        weigth,
        fleetType
      ].includes(null)
    }
  },
  setMassiveCalculationCarKeys: (
    state: AdminSliceState,
    action: PayloadAction<any>
  ) => {
    state.massiveCalculation.carKeys = action.payload
    const { country, distanceKlm, vehicleModel, vehicleFuel } =
            state.massiveCalculation.carKeys
    state.massiveCalculation.isNextButtonDisabled = [
      country,
      distanceKlm,
      vehicleModel,
      vehicleFuel
    ].includes(null)
  },
  setMassiveCalculationPlaneKeys: (
    state: AdminSliceState,
    action: PayloadAction<any>
  ) => {
    state.massiveCalculation.planeKeys = action.payload
    const { from, to, paxes, classType, roundtrip } =
            state.massiveCalculation.planeKeys
    state.massiveCalculation.isNextButtonDisabled = [
      from,
      to,
      paxes,
      classType,
      roundtrip
    ].includes(null)
  },
  setMassiveCalculationParcelKeys: (
    state: AdminSliceState,
    action: PayloadAction<any>
  ) => {
    state.massiveCalculation.parcelKeys = action.payload
    const { from, to, weigth, fleetType } =
            state.massiveCalculation.parcelKeys
    state.massiveCalculation.isNextButtonDisabled = [
      from,
      to,
      weigth,
      fleetType
    ].includes(null)
  },
  resetMassiveCalculationKeys: (state: AdminSliceState) => {
    state.massiveCalculation.planeKeys =
            initialState.massiveCalculation.planeKeys
    state.massiveCalculation.carKeys =
            initialState.massiveCalculation.carKeys
    state.massiveCalculation.parcelKeys =
            initialState.massiveCalculation.parcelKeys
  },
  setMassiveCalculationLoadingPreview: (
    state: AdminSliceState,
    action: PayloadAction<boolean>
  ) => {
    state.massiveCalculation.loadingPreview = action.payload
  },
  setMassiveCalculationPreviewList: (
    state: AdminSliceState,
    action: PayloadAction<any>
  ) => {
    state.massiveCalculation.preViewList = action.payload
  },
  setMassiveCalculationResponseLoading: (
    state: AdminSliceState,
    action: PayloadAction<boolean>
  ) => {
    state.massiveCalculation.responseCalculate.loading = action.payload
  },
  setMassiveCalculationResponseResetData: (state: AdminSliceState) => {
    state.massiveCalculation.responseCalculate.data = []
  },
  setMassiveCalculationResponseAddData: (
    state: AdminSliceState,
    action: PayloadAction<any>
  ) => {
    const oldList = state.massiveCalculation.responseCalculate.data
    const calculeUrl = state.massiveCalculation.calculeUrl
    if (calculeUrl?.endsWith('domestic/delivery/massive')) {
      state.massiveCalculation.responseCalculate.data = [
        ...oldList,
        ...action.payload
      ]
    } else {
      state.massiveCalculation.responseCalculate.data = [
        ...oldList,
        action.payload
      ]
    }
  },
  setMassiveCalculationResponseErrorMessage: (
    state: AdminSliceState,
    action: PayloadAction<string>
  ) => {
    state.massiveCalculation.responseCalculate.errorMessage = action.payload
  },

  /* Brokerage Reducers */
  setBrokerageSelectedTag: (
    state: AdminSliceState,
    action: PayloadAction<string>
  ) => {
    state.brokerage.selectedTab = action.payload
  },
  setBrokerageSalePriceCurrency: (
    state: AdminSliceState,
    action: PayloadAction<string>
  ) => {
    state.brokerage.baseForm.salePriceCurrency = action.payload
  },
  setBrokeragePurchasePriceCurrency: (
    state: AdminSliceState,
    action: PayloadAction<string>
  ) => {
    state.brokerage.baseForm.purchasePriceCurrency = action.payload
  },

  /* Admin Users Reducers */
  setAdminUsersLoading: (
    state: AdminSliceState,
    action: PayloadAction<boolean>
  ) => {
    state.users.loading = action.payload
  },
  setAdminUsersData: (
    state: AdminSliceState,
    action: PayloadAction<UsersAdmin[]>
  ) => {
    state.users.data = action.payload
  },
  setAdminUsersTextFilter: (
    state: AdminSliceState,
    action: PayloadAction<string>
  ) => {
    state.users.filterText = action.payload
  },
  setAdminUsersFilterTypeOption: (
    state: AdminSliceState,
    action: PayloadAction<FilterUserTypeOption>
  ) => {
    state.users.filterTypeOption = action.payload
  },
  setAdminUsersFilterStatusOption: (
    state: AdminSliceState,
    action: PayloadAction<FilterUserStatusOption>
  ) => {
    state.users.filterStatusOption = action.payload
  },
  setAdminUsersFilterGroupOption: (
    state: AdminSliceState,
    action: PayloadAction<string>
  ) => {
    state.users.filterGroupOption = action.payload
  },
  resetAdminUsersState: (state: AdminSliceState) => {
    state.users = initialState.users
  },

  /* Validate Users Reducers */
  setValidateUserLoading: (
    state: AdminSliceState,
    action: PayloadAction<boolean>
  ) => {
    state.users.validateUser.loading = action.payload
  },
  setValidateUserSuccess: (
    state: AdminSliceState,
    action: PayloadAction<boolean>
  ) => {
    state.users.validateUser.success = action.payload
  },
  setValidateUserError: (
    state: AdminSliceState,
    action: PayloadAction<any>
  ) => {
    state.users.validateUser.success = action.payload
  },
  setValidateUserCurrentId: (
    state: AdminSliceState,
    action: PayloadAction<number>
  ) => {
    state.users.validateUser.currencUserId = action.payload
  },
  resetValidateUserState: (state: AdminSliceState) => {
    state.users.validateUser = initialState.users.validateUser
  },

  /* Reject Users Reducers */
  setRejectUserLoading: (
    state: AdminSliceState,
    action: PayloadAction<boolean>
  ) => {
    state.users.rejectUser.loading = action.payload
  },
  setRejectUserSuccess: (
    state: AdminSliceState,
    action: PayloadAction<boolean>
  ) => {
    state.users.rejectUser.success = action.payload
  },
  setRejectUserError: (
    state: AdminSliceState,
    action: PayloadAction<any>
  ) => {
    state.users.rejectUser.success = action.payload
  },
  setRejectUserCurrentId: (
    state: AdminSliceState,
    action: PayloadAction<number>
  ) => {
    state.users.rejectUser.currencUserId = action.payload
  },
  resetRejectUserState: (state: AdminSliceState) => {
    state.users.rejectUser = initialState.users.rejectUser
  },

  // Withdrawals Reducers
  resetWithdrawalState: (state: AdminSliceState) => {
    state.withdrawals = initialState.withdrawals
  },
  setWithdrawalsLoading: (
    state: AdminSliceState,
    action: PayloadAction<boolean>
  ) => {
    state.withdrawals.loading = action.payload
  },
  setWithdrawalsData: (
    state: AdminSliceState,
    action: PayloadAction<Withdrawal[]>
  ) => {
    state.withdrawals.data = action.payload
  },
  setWithdrawalsFilterStatus: (
    state: AdminSliceState,
    action: PayloadAction<'ALL' | 'pending'>
  ) => {
    state.withdrawals.filterStatus = action.payload
  },
  setWithdrawalsFilterText: (
    state: AdminSliceState,
    action: PayloadAction<string>
  ) => {
    state.withdrawals.filterText = action.payload
  },

  // Validate Withdrawal
  resetValidateWithdrawalState: (state: AdminSliceState) => {
    state.withdrawals.validateWithdrawal =
            initialState.withdrawals.validateWithdrawal
  },
  setValidateWithdrawalsLoading: (
    state: AdminSliceState,
    action: PayloadAction<boolean>
  ) => {
    state.withdrawals.validateWithdrawal.loading = action.payload
  },
  setValidateWithdrawalsSuccess: (
    state: AdminSliceState,
    action: PayloadAction<boolean>
  ) => {
    state.withdrawals.validateWithdrawal.success = action.payload
  },
  setValidateWithdrawalsError: (
    state: AdminSliceState,
    action: PayloadAction<any>
  ) => {
    state.withdrawals.validateWithdrawal.error = action.payload
  },
  setValidateCurrenctWithdrawalId: (
    state: AdminSliceState,
    action: PayloadAction<number>
  ) => {
    state.withdrawals.validateWithdrawal.currenctWithdrawal = action.payload
  },

  // Cancel Withdrawal
  resetCancelWithdrawalState: (state: AdminSliceState) => {
    state.withdrawals.cancelWithdrawal =
            initialState.withdrawals.cancelWithdrawal
  },
  setCancelWithdrawalsLoading: (
    state: AdminSliceState,
    action: PayloadAction<boolean>
  ) => {
    state.withdrawals.cancelWithdrawal.loading = action.payload
  },
  setCancelWithdrawalsSuccess: (
    state: AdminSliceState,
    action: PayloadAction<boolean>
  ) => {
    state.withdrawals.cancelWithdrawal.success = action.payload
  },
  setCancelWithdrawalsError: (
    state: AdminSliceState,
    action: PayloadAction<any>
  ) => {
    state.withdrawals.cancelWithdrawal.error = action.payload
  },
  setCancelCurrenctWithdrawalId: (
    state: AdminSliceState,
    action: PayloadAction<number>
  ) => {
    state.withdrawals.cancelWithdrawal.currenctWithdrawal = action.payload
  },

  // Documents
  resetDocumentsState: (state: AdminSliceState) => {
    state.documents = initialState.documents
  },
  setDocumentsLoading: (
    state: AdminSliceState,
    action: PayloadAction<boolean>
  ) => {
    state.documents.loading = action.payload
  },
  setDocumentsData: (
    state: AdminSliceState,
    action: PayloadAction<PurchaseDocument[]>
  ) => {
    state.documents.data = action.payload
  },
  setDocumentsFiltered: (
    state: AdminSliceState,
    action: PayloadAction<PurchaseDocument[]>
  ) => {
    state.documents.filtered = action.payload
  },
  setDocumentsFilteredText: (
    state: AdminSliceState,
    action: PayloadAction<string>
  ) => {
    state.documents.filterText = action.payload
  },
  setDocumentsIsAllCollapse: (
    state: AdminSliceState,
    action: PayloadAction<boolean>
  ) => {
    state.documents.isAllCollapse = action.payload
  },

  // Validate Cancellation Documents
  setValidateCancelationValue: (
    state: AdminSliceState,
    action: PayloadAction<{
            key: string
            value: any
        }>
  ) => {
    const { key, value } = action.payload
    state.documents.validateCancellation[String(key)] = value
  },
  resetValidateCancelationState: (state: AdminSliceState) => {
    state.documents.validateCancellation =
            initialState.documents.validateCancellation
  },

  // Validate Receipt Reducers
  setValidateReceiptValue: (
    state: AdminSliceState,
    action: PayloadAction<{
            key: string
            value: any
        }>
  ) => {
    const { key, value } = action.payload
    state.documents.validateReceipt[String(key)] = value
  },
  resetValidateReceiptState: (state: AdminSliceState) => {
    state.documents.validateReceipt = initialState.documents.validateReceipt
  },

  // Validate Tax Relief Reducers
  setValidateTaxReliefValue: (
    state: AdminSliceState,
    action: PayloadAction<{
            key: string
            value: any
        }>
  ) => {
    const { key, value } = action.payload
    state.documents.validateTaxRelief[String(key)] = value
  },
  resetValidateTaxReliefState: (state: AdminSliceState) => {
    state.documents.validateTaxRelief =
            initialState.documents.validateTaxRelief
  },

  // Validate Carbon Forward Reducers
  setValidateCarbonForwardfValue: (
    state: AdminSliceState,
    action: PayloadAction<{
            key: string
            value: any
        }>
  ) => {
    const { key, value } = action.payload
    state.documents.validateCarbonForwardFile[String(key)] = value
  },
  resetValidateCarbonForwardFile: (state: AdminSliceState) => {
    state.documents.validateCarbonForwardFile =
            initialState.documents.validateCarbonForwardFile
  },

  // -------------------------------- Transfer Reducers   ------------------------------------------------
  resetTransferState: (state: AdminSliceState) => {
    state.transfer = initialState.transfer
  },
  setTransferLoading: (
    state: AdminSliceState,
    action: PayloadAction<boolean>
  ) => {
    state.transfer.loading = action.payload
  },
  setTransferData: (
    state: AdminSliceState,
    action: PayloadAction<AdminTransfer[]>
  ) => {
    state.transfer.data = action.payload
  },
  setTransferFiltered: (
    state: AdminSliceState,
    action: PayloadAction<AdminTransfer[]>
  ) => {
    state.transfer.filtered = action.payload
  },
  // Validate Tax Relief Reducers
  setValidateTransferValue: (
    state: AdminSliceState,
    action: PayloadAction<{
            key: string
            value: any
        }>
  ) => {
    const { key, value } = action.payload
    state.transfer.validateTransfer[String(key)] = value
  },
  setRejectTransferValue: (
    state: AdminSliceState,
    action: PayloadAction<{
            key: string
            value: any
        }>
  ) => {
    const { key, value } = action.payload
    state.transfer.rejectTransfer[String(key)] = value
  },
  resetRejectTransferState: (state: AdminSliceState) => {
    state.transfer.validateTransfer = initialState.transfer.rejectTransfer
  },

  resetValidateTransferState: (state: AdminSliceState) => {
    state.transfer.validateTransfer = initialState.transfer.validateTransfer
  },

  // -------------------------------- Deposits Reducers   ------------------------------------------------
  resetAdminDepositsState: (state: AdminSliceState) => {
    state.deposits = initialState.deposits
  },
  setAdminDepositsLoading: (
    state: AdminSliceState,
    action: PayloadAction<boolean>
  ) => {
    state.deposits.loading = action.payload
  },
  setAdminDepositsData: (
    state: AdminSliceState,
    action: PayloadAction<AdminDeposit[]>
  ) => {
    state.deposits.data = action.payload
  },
  // -------------------------------- Suppliers Reducers   ------------------------------------------------
  resetAdminSuppliersState: (state: AdminSliceState) => {
    state.suppliersAPICron = initialState.suppliersAPICron
  },
  setAdminSuppliersLoading: (
    state: AdminSliceState,
    action: PayloadAction<boolean>
  ) => {
    state.suppliersAPICron.loading = action.payload
  },
  setAdminSuppliersSuccess: (
    state: AdminSliceState,
    action: PayloadAction<boolean>
  ) => {
    state.suppliersAPICron.success = action.payload
  },
  setAdminSuppliersError: (
    state: AdminSliceState,
    action: PayloadAction<boolean>
  ) => {
    state.suppliersAPICron.error = action.payload
  }
}

export { reducers }
